var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5660",
    "data-name": "Group 5660",
    transform: "translate(-1700 -40)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687",
    "data-name": "Rectangle 1687",
    width: 65,
    height: 65,
    rx: 32.5,
    transform: "translate(1700 40)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("g", {
    id: "translate_1_",
    "data-name": "translate (1)",
    transform: "translate(1720 39.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5413",
    "data-name": "Group 5413",
    transform: "translate(0 21.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5412",
    "data-name": "Group 5412",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67635",
    "data-name": "Path 67635",
    d: "M13.489,36.191h0L10.6,33.339l.034-.034a19.909,19.909,0,0,0,4.216-7.42h3.33V23.606H10.227V21.333H7.955v2.273H0v2.261H12.693a17.947,17.947,0,0,1-3.6,6.091,17.92,17.92,0,0,1-2.625-3.807H4.193A19.957,19.957,0,0,0,7.58,33.333L1.8,39.043l1.608,1.608,5.682-5.682L12.625,38.5Z",
    transform: "translate(0 -21.333)",
    fill: "#f5f7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67636",
    "data-name": "Path 67636",
    d: "M242.052,192H239.78l-5.114,13.636h2.273l1.278-3.409h5.4l1.278,3.409h2.273Zm-2.983,7.955,1.847-4.926,1.847,4.926Z",
    transform: "translate(-222.166 -182.909)",
    fill: "#f5f7fd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.e815c6db6ea43d57ae35fd908a7f26a7.svg";
export { ForwardRef as ReactComponent };